import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import set from 'lodash/set';
import flatten from 'lodash/flatten';
import omit from 'lodash/omit';

const INIT_MODIFY = 'homeservice.reapply/INIT_MODIFY';
export const initModify = createAction(INIT_MODIFY);

// 로그인 된 유저정보로 7일이내 신청취소 내역 조회
const GET_REAPPLY_BY_INFO = 'homeservice.reapply/GET_REAPPLY_BY_INFO';
export const getReapplyByInfo = createAction(GET_REAPPLY_BY_INFO, api.getSimpleReapplicationsConditions);

const SET_REAPPLY_LOADING = 'homeservice.reapply/SET_REAPPLY_LOADING';
export const setReapplyLoading = createAction(SET_REAPPLY_LOADING);

const SET_REAPPLY_CALLBACK_ENTER = 'homeservice.reapply/SET_REAPPLY_CALLBACK_ENTER';
export const setReapplyCallbackEnter = createAction(SET_REAPPLY_CALLBACK_ENTER);

const SET_DELIVERY_COUPON_ID = 'homeservice.reapply/SET_DELIVERY_COUPON_ID';
export const setDeliveryCouponId = createAction(SET_DELIVERY_COUPON_ID);

const GET_LATESTCANCEL = 'homeservice.reapply/GET_LATESTCANCEL';
export const getSimpleReapplicationsConditionsDetailData = createAction(GET_LATESTCANCEL, api.getSimpleReapplicationsConditionsDetail);

const CHANGE = 'homeservice.reapply/CHANGE';
export const change = createAction(CHANGE);

const CHANGE_PARAM_RESTORE = 'homeservice.reapply/CHANGE_PARAM_RESTORE';
export const changeParamRestore = createAction(CHANGE_PARAM_RESTORE);

const CHANGE_NOMINEES = 'homeservice.reapply/CHANGE_NOMINEES';
export const changeNominees = createAction(CHANGE_NOMINEES);

const CHANGE_ADDRESS = 'homeservice.reapply/CHANGE_ADDRESS';
export const changeAddress = createAction(CHANGE_ADDRESS);

const CHANGE_SHIPPING_ADDRESS = 'homeservice.reapply/CHANGE_SHIPPING_ADDRESS';
export const changeShippingAddress = createAction(CHANGE_SHIPPING_ADDRESS);

const CHANGE_TERMS = 'homeservice.reapply/CHANGE_TERMS';
export const changeTerms = createAction(CHANGE_TERMS);

const GET_ADDRESS = 'homeservice.reapply/GET_ADDRESS';
export const getAddressData = createAction(GET_ADDRESS, api.getAddress);

const GET_WARRANTY = 'homeservice.reapply/GET_WARRANTY';
export const getExtendedWarranty = createAction(GET_WARRANTY, api.getExtendedWarranty);

const POST_REAPPLICATION = 'homeservice.reapply/POST_REAPPLICATION';
export const postReapplication = createAction(POST_REAPPLICATION, api.postHomeServiceReapplication);

const CHANGE_BUSINESS_ADDRESS = 'homeservice.reapply/CHANGE_BUSINESS_ADDRESS';
export const changeBusinessAddress = createAction(CHANGE_BUSINESS_ADDRESS);

const RESET_REAPPLY = 'homeservice.reapply/RESET_REAPPLY';
export const reset_reapply = createAction(RESET_REAPPLY);

// 재신청 완료 후 리셋처리
const RESET = 'homeservice.reapply/RESET';
export const reset = createAction(RESET);

const initParamInfo = {
	carId: null,
	paymentMethod: null,
	firstPaymentMethod: null,
	applicationMethod: 'MOBILE',
	extendedWarrantyMonth: 0,
	loanVersion: null,
	applicant: {
		id: 0,
		userId: '',
		name: '',
		phone: '',
		email: '',
		refundAccount: {
			name: '',
			bank: '',
			number: '',
		},
		shippingAddress: {
			buildingCd: '',
			detail: '',
			zipCd: '',
			addressDetail: '',
		},
	},
	nominees: [
		{
			nomineeType: 'PERSONAL_MAIN',
			name: '', // 명의자 이름
			phone: '', // 명의자 번호
			email: '',
			gender: null,
			birth: '',
			invoice: {
				// 세금계산서
				email: '',
			},
			ownershipRate: 100,
			postalAddress: {
				// 우편등기 주소
				buildingCd: '',
				detail: '',
				zipCd: '',
				addressDetail: '',
			},
			certifiedAddress: {
				// 명의자 정보 주소
				buildingCd: '',
				detail: '',
				zipCd: '',
				addressDetail: '',
			},
			corporateName: '',
			businessName: '',
			businessNumber: '',
			businessAddress: {
				// 사업자 정보 주소
				buildingCd: '',
				detail: '',
				zipCd: '',
				addressDetail: '',
			},
		},
		{
			nomineeType: '',
			name: '',
			phone: '',
			email: '',
			gender: '',
			birth: '',
			ownershipRate: 0,
			certifiedAddress: {
				buildingCd: '',
				detail: '',
				zipCd: '',
				addressDetail: '',
			},
		},
	],
};

const initInfo = {
	isInitModify: false,
	isReapplyLoading: false,
	isReapplyCallbackEnter: false,
	param: initParamInfo,
	ui: {
		isLoading: false,
		isSameAccount: false,
		isSameRequest: false,
		isSameNomineesRequest: false,
		isSameBusinessAddressAsPostalAddress: false,
		isSameCertifiedAddressAsPostalAddress: false,
		isSameNominees: false,
		isSameBusinessAddress: false,
		allTermsFinance: false,
		certificationNumber: '',
		phoneKey: {},
		phoneKeyAuth: false,
		phoneTimer: 180,
		isTimeout: false,
		hasWarranty: false,
		hasAdvertisement: false,
		warrantyList: [],
		refundTerms: {
			refundRule: false,
		},
		warrantyTerms: {
			privacyWarranty: false,
			provide: false,
			refundWarranty: false,
		},
		isAvailableModify: false,
		isTermsAgreement: false,
		// 사용자가 보증 제외를 명시 선택했는지 (persist 복원 후 initWarranty가 기본 개월로 덮어쓰는 것을 방지)
		isWarrantyExcluded: false,
	},
	validation: {
		name: false,
		phone: false,
		phoneAuth: false,
		nameText: '',
		phoneText: '',
		phoneAuthText: '',
		terms: {
			privacyWarranty: false,
			provide: false,
			refundWarranty: false,
		},
		shippingAddress: false,
		shippingAddressText: '',
		birth: false,
		birthText: '',
	},
	validationNominees: {
		name: false,
		name2: false,
		phone: false,
		phone2: false,
		postalAddress: false,
		businessAddress: false,
		invoiceEmail: false,
		nameText: '',
		nameText2: '',
		phoneText: '',
		phoneText2: '',
		postalAddressText: '',
		businessAddressText: '',
		invoiceEmailText: '',
		ownershipRate: false,
		ownershipRateText: '',
		nomineesOwnershipRate: false,
		nomineesownershipRateText: '',
		businessNumber: false,
		businessNumberText: '',
		corporateName: false,
		corporateNameText: '',
		birth: false,
		birthText: '',
	},
	// 홈서비스 재신청 관련 정보
	reapplyInfo: {
		isHsReapply: false,
		uuid: '',
	},
	// 홈서비스 재신청 엔카페이 간편조회 hash
	encarPayHash: '',
	// 무료배송 쿠폰 ID (재신청 플로우)
	deliveryCouponId: null,
};

const initialState = initInfo;

const onError = (state) =>
	produce(state, (draft) => {
		draft.reapplyInfo = {
			isEncarpayReapply: false,
			isHsReapply: false,
			uuid: '',
		};
	});

export default handleActions(
	{
		[RESET]: (state) =>
			produce(state, (draft) => {
				Object.assign(draft, initInfo);
			}),

		[INIT_MODIFY]: (state, action) =>
			produce(state, (draft) => {
				draft.isInitModify = action.payload;

				return draft;
			}),

		[SET_REAPPLY_LOADING]: (state, action) =>
			produce(state, (draft) => {
				draft.isReapplyLoading = action.payload;

				return draft;
			}),

		[SET_REAPPLY_CALLBACK_ENTER]: (state, action) =>
			produce(state, (draft) => {
				draft.isReapplyCallbackEnter = action.payload;

				return draft;
			}),

		[SET_DELIVERY_COUPON_ID]: (state, action) =>
			produce(state, (draft) => {
				draft.deliveryCouponId = action.payload;

				return draft;
			}),

		[CHANGE]: (state, action) =>
			produce(state, (draft) => {
				const { schema, name, value } = action.payload;

				set(draft, flatten([schema, name]), value);

				return draft;
			}),

		[CHANGE_PARAM_RESTORE]: (state, action) =>
			produce(state, (draft) => {
				const { data } = action.payload;

				draft.param = {
					...draft.param,
					...data,
				};

				return draft;
			}),

		[CHANGE_BUSINESS_ADDRESS]: (state, action) =>
			produce(state, (draft) => {
				const { type, name, value, index } = action.payload;

				set(draft, ['param', 'nominees', index || 0, type, name], value);

				return draft;
			}),

		[CHANGE_TERMS]: (state, action) =>
			produce(state, (draft) => {
				// schema: param, ui 등
				// termsCategory: termsAgreement 등
				// name: termsAgreement안에 있는 아이템
				const { schema, termsCategory, name, value } = action.payload;
				set(draft, [schema, termsCategory, name], value);

				return draft;
			}),

		[CHANGE_NOMINEES]: (state, action) =>
			produce(state, (draft) => {
				const { name, value, index } = action.payload;

				set(draft, ['param', 'nominees', index || 0, name], value);

				return draft;
			}),

		[CHANGE_ADDRESS]: (state, action) =>
			produce(state, (draft) => {
				const { type, name, value, index } = action.payload;

				set(draft, ['param', 'nominees', index || 0, type, name], value);

				return draft;
			}),

		[CHANGE_SHIPPING_ADDRESS]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;

				set(draft, ['param', 'applicant', 'shippingAddress', name], value);

				return draft;
			}),

		[RESET_REAPPLY]: (state) => ({
			...state,
			reapplyInfo: {
				isEncarpayReapply: false,
				isHsReapply: false,
				uuid: '',
			},
		}),

		...pender({
			type: GET_LATESTCANCEL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { applicant, nominees, payment, carId, loan } = data;

					const createNominee = (nominee) => ({
						...draft.param.nominees[0],
						...nominee,
						...(nominee.businessAddress && {
							businessAddress: {
								...nominee.businessAddress,
								buildingCd: nominee.businessAddress.buildingCd,
								detail: nominee.businessAddress.detail,
							},
						}),
						...(nominee.postalAddress && {
							postalAddress: {
								...nominee.postalAddress,
								buildingCd: nominee.postalAddress.buildingCd,
								detail: nominee.postalAddress.detail,
							},
						}),
						...(nominee.certifiedAddress && {
							certifiedAddress: {
								...nominee.certifiedAddress,
								buildingCd: nominee.certifiedAddress.buildingCd,
								detail: nominee.certifiedAddress.detail,
							},
						}),
					});

					let newNominees = nominees.map(createNominee);
					if (nominees.length <= 1) {
						newNominees = [...newNominees, { ...state.param.nominees[1] }];
					}

					const exceptIdNominees = newNominees.map((nominee) => omit(nominee, ['id']));

					draft.param = {
						...draft.param,
						carId,
						applicant: {
							...draft.param.applicant,
							id: applicant.id,
							name: applicant.name,
							phone: applicant.phone,
							email: applicant.email,
							userId: applicant.userId,
							shippingAddress: {
								...draft.param.applicant.shippingAddress,
								buildingCd: applicant?.shippingAddress?.buildingCd,
								detail: applicant?.shippingAddress?.detail,
							},
						},
						nominees: exceptIdNominees,
						paymentMethod: payment.activePaymentMethod,
						firstPaymentMethod: payment.firstPaymentMethod,
						loanVersion: loan?.version ?? draft.param.loanVersion,
					};
					draft.ui = {
						...draft.ui,
						isSameNominees: nominees.length >= 2,
					};

					draft.isReapplyLoading = true;

					return draft;
				}),
		}),

		...pender({
			type: GET_WARRANTY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					const warrantyList = data
						.map((item) => ({
							...item,
							isWarranty: true,
						}))
						.concat({
							code: 'E01',
							month: 0,
							cost: 0,
							isWarranty: false,
						});

					set(draft, ['ui', 'hasWarranty'], true);
					set(draft, ['ui', 'warrantyList'], warrantyList);
					set(draft, ['ui', 'hasAdvertisement'], data[0].hasAdvertisement);

					return draft;
				}),
		}),

		...pender({
			type: GET_REAPPLY_BY_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { reapplicable, latestCancelledApplicationUuid } = data;
					draft.reapplyInfo = {
						isHsReapply: !!(reapplicable && latestCancelledApplicationUuid),
						uuid: latestCancelledApplicationUuid,
					};
				}),
			onError,
		}),
	},
	initialState,
);
